import { Flex, Paper, Title, Button, Text } from '@mantine/core';
import { IconPencil } from '@tabler/icons-react';
import { Point, ItemPoint, DangerouslySetInnerHTML } from '@shared/ui';
import { NccVerifiedStatusIcon } from '@entities/company';

type CompanyInfoAboutProps = {
  companyName: string;
  companyType: string;
  companyNif: string;
  companyNccVerified?: boolean | null;
  companyCity: string;
  companyManager: string;
  companyEconomicActivities: string;
  companyDescription: string;
  handleEdit: () => void;
};

export const CompanyInfoAbout = ({
  companyName,
  companyType,
  companyNif,
  companyNccVerified,
  companyCity,
  companyManager,
  companyEconomicActivities,
  companyDescription,
  handleEdit,
}: CompanyInfoAboutProps) => {
  return (
    <Paper p={24} radius={16} bg='primary.0' w='100%' maw={1070}>
      <Flex gap={24} direction='column'>
        <Flex w='100%' justify='space-between' wrap='wrap'>
          <Title order={4}>Описание компании</Title>

          <Button
            variant='subtle'
            size='md'
            leftSection={<IconPencil size={20} />}
            onClick={handleEdit}
          >
            Редактировать
          </Button>
        </Flex>

        <Flex gap={24} w='100%' direction='column'>
          <Point title='Компания' value={companyName} />

          <Flex wrap='wrap' w='100%' direction={{ base: 'column', sm: 'row' }}>
            <Point
              title='Форма организации'
              value={companyType}
              containerProps={{ w: '50%' }}
            />
            <Flex direction='column' gap={8} w={{ base: '100%', sm: '50%' }}>
              <Text c='tertiary.7' size='sm'>
                NCC
              </Text>
              <Flex align='center' gap={8}>
                <NccVerifiedStatusIcon nccVerified={companyNccVerified} />
                <Text c='primary.7'>{companyNif}</Text>
              </Flex>
            </Flex>
          </Flex>

          <Point title='Город' value={companyCity} />
          <Point title='Менеджер компании' value={companyManager} />
          <Point
            title='Сфера экономической деятельности'
            value={companyEconomicActivities}
          />

          <ItemPoint
            subTitle='Описание компании'
            text={<DangerouslySetInnerHTML __html={companyDescription} />}
          />
        </Flex>
      </Flex>
    </Paper>
  );
};
